import {
  PAGEFORM_FETCHITEM_LOAD,
  PAGEFORM_FETCHITEM_SUCCEED,
  PAGEFORM_FETCHITEM_FAIL,
  PAGEFORM_EDITFORM_CHANGE,
  PAGEFORM_ENTER_RESET,
  PAGEFORM_CREATEITEM_LOAD,
  PAGEFORM_CREATEITEM_SUCCEED,
  PAGEFORM_CREATEITEM_FAIL,
  PAGEFORM_EDITITEM_LOAD,
  PAGEFORM_EDITITEM_SUCCEED,
  PAGEFORM_EDITITEM_FAIL,
  PAGEFORM_DELETEITEM_LOAD,
  PAGEFORM_DELETEITEM_SUCCEED,
  PAGEFORM_DELETEITEM_FAIL,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case PAGEFORM_FETCHITEM_LOAD:
      return { ...state, isFetchItemLoading: true, fetchItemError: null }
    case PAGEFORM_FETCHITEM_SUCCEED:
      return { ...state, isFetchItemLoading: false, item: action.item }
    case PAGEFORM_FETCHITEM_FAIL:
      return { ...state, isFetchItemLoading: false, fetchItemError: action.fetchItemError }
    case PAGEFORM_ENTER_RESET:
      return {}
    case PAGEFORM_EDITFORM_CHANGE:
      return { ...state, formFieldValues: { ...state.formFieldValues, ...action.field } }
    case PAGEFORM_CREATEITEM_LOAD:
      return {
        ...state,
        isCreateItemLoading: true,
        isCreateItemSuccess: false,
        createItemError: null,
      }
    case PAGEFORM_CREATEITEM_SUCCEED:
      return { ...state, isCreateItemLoading: false, isCreateItemSuccess: true }
    case PAGEFORM_CREATEITEM_FAIL:
      return { ...state, isCreateItemLoading: false, createItemError: action.createItemError }
    case PAGEFORM_EDITITEM_LOAD:
      return {
        ...state,
        isEditItemLoading: true,
        isEditItemSuccess: false,
        editItemError: null,
      }
    case PAGEFORM_EDITITEM_SUCCEED:
      return { ...state, isEditItemLoading: false, isEditItemSuccess: true }
    case PAGEFORM_EDITITEM_FAIL:
      return { ...state, isEditItemLoading: false, editItemError: action.editItemError }
    case PAGEFORM_DELETEITEM_LOAD:
      return {
        ...state,
        isDeleteItemLoading: true,
        isDeleteItemSuccess: false,
        deleteItemError: null,
      }
    case PAGEFORM_DELETEITEM_SUCCEED:
      return { ...state, isDeleteItemLoading: false, isDeleteItemSuccess: true }
    case PAGEFORM_DELETEITEM_FAIL:
      return { ...state, isDeleteItemLoading: false, deleteItemError: action.deleteItemError }
    default:
      return state
  }
}
